import { WebsiteWithConnections } from '../../types/website';
import { Card, Dropdown } from '../ui';
import { InfoField, WebsiteEditForm } from './WebsiteInfoPanel';

interface StatusInfoPanelProps {
  website: WebsiteWithConnections | null;
  isEditMode: boolean;
  editForm: WebsiteEditForm;
  setEditForm: (val: WebsiteEditForm) => void;
  getStatusBadge: (status: string) => JSX.Element;
}

export default function StatusInfoPanel({ website, isEditMode, editForm, setEditForm, getStatusBadge }: StatusInfoPanelProps) {
  return (
    <Card eyebrow="Status" style={{ overflow: 'visible' }}>
      {isEditMode ? (
        <div className="grid grid-cols-1 md:grid-cols-3" style={{ gap: 'var(--space-4)' }}>
          <Dropdown
            label="Build Status"
            options={[
              { value: 'Pending', label: 'Pending' },
              { value: 'In Progress', label: 'In Progress' },
              { value: 'Complete', label: 'Complete' },
              { value: 'Failed', label: 'Failed' }
            ]}
            value={editForm.build_status}
            onChange={(e) => setEditForm({ ...editForm, build_status: e.target.value })}
            placeholder="Build Status"
          />

          <Dropdown
            label="Deployment Status"
            options={[
              { value: 'Pending', label: 'Pending' },
              { value: 'In Progress', label: 'In Progress' },
              { value: 'Live', label: 'Live' },
              { value: 'Failed', label: 'Failed' }
            ]}
            value={editForm.deployment_status}
            onChange={(e) => setEditForm({ ...editForm, deployment_status: e.target.value })}
            placeholder="Deployment Status"
          />

          <Dropdown
            label="Indexing Status"
            options={[
              { value: 'Not Indexed', label: 'Not Indexed' },
              { value: 'Submitted', label: 'Submitted' },
              { value: 'Partial', label: 'Partial' },
              { value: 'Indexed', label: 'Indexed' },
              { value: 'Issues', label: 'Issues' }
            ]}
            value={editForm.indexing_status}
            onChange={(e) => setEditForm({ ...editForm, indexing_status: e.target.value })}
            placeholder="Indexing Status"
          />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-3" style={{ gap: 'var(--space-4)' }}>
          <InfoField label="Build Status">
            {getStatusBadge(website?.build_status || 'Pending')}
          </InfoField>

          <InfoField label="Deployment Status">
            {getStatusBadge(website?.deployment_status || 'Pending')}
          </InfoField>

          <InfoField label="Indexing Status">
            {getStatusBadge(website?.indexing_status || 'Not Indexed')}
          </InfoField>
        </div>
      )}
    </Card>
  );
}
